import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCalculator, FaFileContract, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaChartLine, FaLock } from 'react-icons/fa';

const WebGestoriaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-abogados", text: "Página web barata para abogados" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Genera confianza en tus servicios",
      description: "Una web profesional transmite seriedad y confianza, cualidades esenciales para servicios financieros y administrativos. Aumenta la credibilidad de tu gestoría."
    },
    {
      title: "Capta clientes de mayor valor",
      description: "El 82% de las empresas buscan primero en internet antes de contratar servicios de gestoría. Una web profesional atrae clientes con mayor presupuesto y recurrencia."
    },
    {
      title: "Explica tus servicios con claridad",
      description: "Detalla cada servicio: contabilidad, fiscalidad, laboral, trámites con administraciones... Clientes mejor informados requieren menos tiempo en la primera consulta."
    },
    {
      title: "Destaca sobre tu competencia",
      description: "El 65% de las gestorías tienen webs anticuadas o poco profesionales. Diferénciate con una web moderna que transmita eficiencia y profesionalidad."
    },
    {
      title: "Optimiza tu tiempo de trabajo",
      description: "Reduce consultas básicas sobre servicios y precios. La web filtra clientes, atrayendo aquellos que realmente valoran tus servicios especializados."
    },
    {
      title: "Recupera la inversión rápidamente",
      description: "Con solo un cliente recurrente de valor medio-alto captado a través de la web, recuperas varias veces la inversión en el primer año."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaCalculator />,
      title: "Presentación clara de servicios",
      description: "Categorización profesional de todos tus servicios: fiscal, contable, laboral, mercantil, etc. Explicación detallada que posiciona tu expertise."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a dispositivos",
      description: "Tu web se verá perfecta en ordenadores, tablets y móviles. Experiencia óptima garantizada, incrementando un 35% las conversiones."
    },
    {
      icon: <FaFileContract />,
      title: "Sección de trámites frecuentes",
      description: "Explica los procedimientos más comunes y sus requisitos. Atraerá tráfico orgánico y posicionará tu gestoría como referente en tu especialidad."
    },
    {
      icon: <FaChartLine />,
      title: "SEO para gestorías y asesorías",
      description: "Posicionamiento específico para términos como 'gestoría en [tu ciudad]', 'asesoría fiscal', etc. Aparece cuando los potenciales clientes te buscan."
    },
    {
      icon: <FaUsers />,
      title: "Presentación del equipo profesional",
      description: "Sección para mostrar la experiencia y especialidades de tu equipo. Genera confianza y humaniza tus servicios, aspecto clave en este sector."
    },
    {
      icon: <FaLock />,
      title: "Privacidad y seguridad reforzadas",
      description: "Implementación de protocolos seguros y cumplimiento de normativas RGPD. Esencial para transmitir confianza en el manejo de datos sensibles."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Gestoría Básica',
      price: 200,
      period: 'pago único',
      description: 'Ideal para gestorías que quieren iniciar su presencia digital profesional.',
      features: [
        { text: 'Hasta 5 páginas principales', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Catálogo básico de servicios', included: true },
        { text: 'Formulario de contacto seguro', included: true },
        { text: 'Integración con WhatsApp', included: true },
        { text: 'Textos legales específicos', included: true },
        { text: 'SSL y protección datos RGPD', included: true },
        { text: 'Diseño profesional para el sector', included: true },
        { text: 'Área privada para clientes', included: false },
        { text: 'Optimización SEO avanzada', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=gestoria-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Gestoría Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más elegida. Web completa con funcionalidades profesionales para gestorías que quieren destacar.',
      features: [
        { text: 'Entre 5-10 páginas', included: true },
        { text: 'Diseño adaptado a todos los dispositivos', included: true },
        { text: 'Servicios detallados con imágenes', included: true },
        { text: 'Presentación del equipo profesional', included: true },
        { text: 'Blog de actualidad fiscal/laboral', included: true },
        { text: 'Integración con redes sociales', included: true },
        { text: 'Optimización SEO local', included: true },
        { text: 'Sección de preguntas frecuentes', included: true },
        { text: 'Área cliente básica*', included: false },
        { text: 'Calculadora de servicios', included: false },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=gestoria-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Gestoría Premium',
      price: 400,
      period: 'pago único',
      description: 'Solución completa para gestorías que buscan una experiencia digital de alto nivel para sus clientes.',
      features: [
        { text: 'Entre 10-15 páginas', included: true },
        { text: 'Diseño exclusivo personalizado', included: true },
        { text: 'Servicios con páginas individuales', included: true },
        { text: 'Optimización SEO avanzada', included: true },
        { text: 'Blog con contenido inicial', included: true },
        { text: 'Multiidioma (2 idiomas)', included: true },
        { text: 'Testimonios y casos de éxito', included: true },
        { text: 'Newsletter integrada', included: true },
        { text: 'Área cliente avanzada*', included: false },
        { text: 'Herramientas de cálculo fiscal', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=gestoria-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu gestoría, servicios y cliente ideal. Planificamos una web que transmita profesionalidad y genere confianza en tus servicios.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño sobrio y profesional. Implementamos secciones clave para mostrar tus servicios, experiencia y equipo.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO específicas para servicios profesionales.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para gestorías",
      us: true,
      others: false
    },
    {
      label: "Cumplimiento RGPD garantizado",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO para servicios profesionales",
      us: true,
      others: false
    },
    {
      label: "Presentación profesional de servicios",
      us: true,
      others: false
    },
    {
      label: "Preparada para integrar área de clientes",
      us: true,
      others: false
    },
    {
      label: "Formación específica incluida",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Llevábamos años confiando exclusivamente en el boca a oreja para captar clientes, pero esto limitaba nuestro crecimiento. Desde que lanzamos la web profesional, hemos notado un cambio significativo en el perfil de los clientes que nos contactan: más empresas establecidas, con necesidades recurrentes y mayor presupuesto. La web ha reducido drásticamente el tiempo que dedicamos a explicar servicios básicos, permitiéndonos centrarnos en clientes que realmente valoran nuestra experiencia. La sección de trámites frecuentes ha sido especialmente efectiva para posicionarnos como expertos en nuestro sector.",
    author: "Carlos Martínez",
    position: "Director",
    company: "Gestoría Martínez & Asociados",
    avatar: "/servicios/testimonios/gestoria.webp"
  };
  
  const founderMessage = "En el sector de las gestorías y asesorías, la confianza es el activo más valioso. Desarrollamos webs que transmiten profesionalidad desde el primer vistazo, con un enfoque en presentar servicios complejos de forma clara y accesible. Una presencia digital bien estructurada no solo capta clientes, sino que atrae específicamente aquellos de mayor valor que buscan asesoramiento continuo, no soluciones puntuales.";
  
  // FAQs específicas para web de gestorías
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi gestoría?",
      answer: "Una web profesional es indispensable para gestorías y asesorías por razones estratégicas esenciales: 1) Genera credibilidad y confianza, aspectos fundamentales cuando se manejan temas fiscales y financieros de los clientes; 2) El 82% de las empresas buscan primero en internet antes de contratar servicios profesionales; 3) Atrae un perfil de cliente de mayor valor, filtrando consultas preliminares y optimizando tu tiempo; 4) Permite explicar detalladamente tus servicios y especialidades, diferenciándote de la competencia; 5) Funciona como escaparate 24/7 de tu profesionalidad, especialmente importante para captar clientes empresariales; 6) Posibilita un posicionamiento como experto en nichos específicos (fiscalidad internacional, autónomos, e-commerce, etc.); 7) Complementa el tradicional boca a oreja, ampliando el radio de acción de tu gestoría más allá de los contactos directos. Según estudios del sector, las gestorías con presencia web profesional incrementan entre un 25-40% sus ingresos en el primer año, principalmente por captación de clientes de mayor valor medio y servicios recurrentes.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se presentarán mis servicios en la web?",
      answer: "Tus servicios se presentarán de forma clara, profesional y orientada a generar confianza: 1) Estructura organizativa por áreas (fiscal, contable, laboral, mercantil) con descripciones detalladas de cada servicio; 2) Énfasis en la experiencia y cualificación en cada área, destacando años de experiencia y formación; 3) Explicación de la metodología de trabajo y proceso de colaboración con clientes; 4) Sección específica para destacar especialidades o nichos donde destacas especialmente; 5) Casos de éxito anonimizados que demuestren resultados concretos (ej: 'Ahorro fiscal del 22% para PYME del sector tecnológico'); 6) Integración de testimonios específicos junto a cada servicio; 7) Llamadas a la acción claras para solicitar información o primera consulta gratuita. Este enfoque está diseñado para transmitir profesionalidad y generar confianza, aspectos fundamentales en el sector de asesoría y gestoría, donde los clientes buscan no solo servicios técnicos sino también seguridad y tranquilidad en la gestión de sus asuntos administrativos y fiscales.",
      category: "Contenidos"
    },
    {
      question: "¿Es posible incluir un área privada para clientes?",
      answer: "Sí, aunque los sistemas de área privada no están incluidos en los precios base y se presupuestan por separado debido a su complejidad y personalización: 1) Área cliente básica (desde 200€) - Acceso mediante usuario/contraseña para intercambio de documentos y comunicaciones seguras; 2) Área cliente intermedia (desde 350€) - Incluye notificaciones, calendario fiscal personalizado y organización de documentos por categorías; 3) Área cliente avanzada (desde 600€) - Sistema completo con dashboard personalizado, alertas automáticas, histórico de trámites y facturación integrada. Estos sistemas requieren configuración específica según tu forma de trabajo y servicios. Todos cumplen con las normativas RGPD y utilizan conexiones encriptadas para garantizar la seguridad de los datos sensibles. También podemos integrar tu web con plataformas específicas para gestorías si ya utilizas alguna. El coste exacto se determina tras analizar tus necesidades específicas, volumen de clientes y funcionalidades requeridas, por lo que se presupuesta individualmente.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas, adecuado para cada nivel: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, servicios, sobre nosotros, equipo y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, ampliando con secciones como blog especializado, páginas específicas para servicios principales (por ejemplo: asesoría fiscal, laboral, contable), preguntas frecuentes y recursos útiles; 3) El plan Premium (400€) permite entre 10-15 páginas, incluyendo páginas detalladas para cada servicio, casos de éxito, recursos descargables, contenido multiidioma o secciones específicas por tipo de cliente (autónomos, sociedades, etc.). Si necesitas más páginas de las incluidas en tu plan, tienen un coste adicional de 40€ por página. Para webs más extensas, recomendamos solicitar un presupuesto personalizado. La mayoría de gestorías obtienen excelentes resultados con las páginas incluidas en los planes estándar, ya que lo importante es la calidad y enfoque del contenido, no la cantidad.",
      category: "Planes"
    },
    {
      question: "¿Qué tipo de contenido es más efectivo para una gestoría?",
      answer: "El contenido más efectivo para gestorías y asesorías es aquel que demuestra experiencia y genera confianza: 1) Artículos explicativos sobre novedades fiscales y laborales, que posicionan tu gestoría como actualizada y experta; 2) Guías paso a paso sobre trámites frecuentes, muy útiles para atraer tráfico orgánico; 3) Estudios de caso anonimizados que demuestren resultados tangibles; 4) Preguntas frecuentes (FAQs) sobre aspectos fiscales, contables o laborales que muestren tu conocimiento; 5) Recursos descargables como calendarios fiscales o checklists; 6) Presentación detallada del equipo, destacando cualificaciones y experiencia; 7) Testimonios específicos para diferentes tipos de servicios. Este enfoque convierte tu web en una herramienta no solo promocional sino también útil para potenciales clientes, posicionándote como un recurso valioso en tu sector. Durante la creación de tu web, te asesoraremos sobre el tipo de contenido más efectivo según tu especialización y público objetivo, y redactaremos el contenido inicial optimizado para SEO y conversión.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye servicios esenciales para garantizar el funcionamiento óptimo y seguro de tu web: 1) Alojamiento en servidores de alta seguridad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL avanzado; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad prioritarias; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar información, publicar artículos en el blog, modificar servicios o añadir testimonios de clientes. Para gestorías, es particularmente importante mantener la web actualizada con cambios normativos o novedades fiscales, por lo que incluimos formación específica. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, la seguridad de los datos y el alojamiento seguro de los contenidos, especialmente importante para gestorías donde se manejan datos sensibles.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para gestorías
      pageTitle="Web para Gestorías desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para gestorías y asesorías. Presenta tus servicios con claridad, transmite confianza y capta clientes de mayor valor."
      pageKeywords="página web barata gestoría, web para gestorías, diseño web asesoría, página web gestoría barata, web asesoría económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-gestoria"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para gestorías desde 200€ (consigue clientes mientras gestionas)"
      heroSubtitle="Diseño web profesional para gestorías y asesorías. Transmite profesionalidad, comunica tus servicios y genera confianza para convertir visitas en clientes."
      heroImage="/servicios/tipo-cliente/hero-gestoria.webp"
      badges={['Desde 200€ (pago único)', 'Textos legales incluidos', 'Área de clientes', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para gestorías y asesorías"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes. *Áreas privadas de cliente presupuestadas aparte."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para gestorías?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Jaime Vela"
          founderTitle="Co-fundador y Director de Marketing"
          avatarSrc="/sobre nosotros/foto-jaime.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de gestoría?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu gestoría"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para gestorías"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu gestoría con presencia online profesional"
      ctaDescription="Una inversión inteligente que transmitirá confianza, explicará tus servicios con claridad y atraerá clientes de mayor valor. Recupera la inversión rápidamente."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebGestoriaPage; 

